import { createApiAction } from '@app/packages/api/utils'
import type { V3GetBonusesResponse } from '@app/packages/api/v3/types/responses'

export const getBonuses = () =>
  createApiAction('getBonuses', dispatch =>
    dispatch<V3GetBonusesResponse>({
      endpoint: '/api/v3/bonuses',
      method: 'GET',
    })
  )
